import { fetchGet } from './api';
import { ISchool } from '../types/school.type';

export const fetchSchools = () => fetchGet<ISchool[]>('schools');
